import React, { useState, useEffect, Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    Row,
    Button,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import Outbound_image from '../../../../../assets/outbound.png';
import { TriggerForm } from './components/TriggerForm';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_OutboundTrigger_By_PropertyId
} from '../../../../../constants/APIs';
import { TriggerList } from './components/TriggerList';
function Index({ propertyId }) {
    const [loading, setLoading] = useState(true);
    const [isVisible, setIsVisible] = useState(false);
    const [outboundTriggerList, setOutTriggerList] = useState([]);
    // if (loading) {
    //     return <div className="loading" />;
    // }
    useEffect(() => {
        LoadData();
    }, [propertyId]);

    const LoadData = () => {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_OutboundTrigger_By_PropertyId}?propertyId=${propertyId}`,
        })
            .then((res) => {
                 const filtered = (res.data || []).filter(
                (item) => item.status !== "Archieve"
            );
                setOutTriggerList(filtered);
                setLoading(false);
            })
            .catch((err) => console.log('err', err));
    };
    //console.log(outboundTriggerList);
    return (
        <Fragment>
            <Row className="app-row survey-app">
                <Colxx xxs="12">
                    <div className="mb-2">
                        <h1>Outbound Triggers</h1>
                        {!loading && outboundTriggerList && outboundTriggerList.length > 0 && (
                            <Fragment>
                                <div className="text-zero top-right-button-container">
                                    <Button
                                        color="primary"
                                        size="lg"
                                        className="top-right-button mr-1"
                                        onClick={() => setIsVisible(true)}
                                    >
                                        Add Your Outbound Trigger
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </Colxx>
            </Row>
            <Separator className="mb-5" />
            {outboundTriggerList && outboundTriggerList.length > 0 ?
                <Row>
                    <Colxx xxs="12">
                        <div className="equal-height-container mb-5 row text-center">
                            {outboundTriggerList.map((rule, index) => (
                                <TriggerList
                                    item={rule}
                                    index={index}
                                    LoadData={LoadData}
                                    propertyId={propertyId}></TriggerList>))}
                        </div>
                    </Colxx>
                </Row>
                :
                <div style={{
                    position: 'absolute',
                    left: '35%',
                    padding: "10px",
                    top: "10rem"
                }}>
                    <div><img src={Outbound_image} alt="outbound" style={{ maxWidth: '450px' }} /></div>
                    <div style={{
                        position: "relative",
                        bottom: "26px",
                        padding: "20px",
                        marginLeft: "5rem",
                    }}>
                        <Button
                            color="primary"
                            size="lg"
                            className="top-right-button mr-1"
                            onClick={() => setIsVisible(true)}
                        >
                            Add your first outbound Trigger
                        </Button>
                    </div>
                </div>
            }
            {isVisible && (
                <TriggerForm
                    visible={isVisible}
                    toggle={() => setIsVisible(!isVisible)}
                    formLabel={"Create"}
                    propertyId={propertyId}
                    LoadData={LoadData}>
                </TriggerForm>
            )}
        </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));